import { Provider, importProvidersFrom } from '@angular/core';

import { StoreModule } from '@ngrx/store';

import { FieldStakeInputModeStrategy, StakeInputModeStrategy } from './stake-input-mode.strategy';
import { numpadFeatureKey } from './store/numpad.state';
import { numpadReducer } from './store/reducer';

export const provideNumpad = (): Provider => [
    { provide: StakeInputModeStrategy, useClass: FieldStakeInputModeStrategy },
    importProvidersFrom(StoreModule.forFeature(numpadFeatureKey, numpadReducer)),
];
